export default {
  loading: {
    text: "Loading...",
  },
  title: "Address Transfer Status",
  subtitle: "Statistics Currency: ",
  dialogTitle: "Address Transfer Status",
  empty: "No data",
  filters: {
    currency: "Currency",
    selectCurrency: "Select currency",
  },
  types: {
    transactionAmount: "Amount",
    transactionCount: "Count",
  },
  units: {
    amount: " Amount",
    times: " Times",
  },
  actions: {
    enlarge: "Enlarge",
  },
};
